import axios, { axiosSpring } from '../axios';
import useAuth from '../auth/useAuth';
import { useEffect, useRef } from 'react';

const useRefreshToken = () => {
    const { auth, setAuth } = useAuth();

    const refresh = async () => {
        const response = await axiosSpring.get('/api/refresh', {
            withCredentials: true
        });
        // console.log(response?.data);

        setAuth((prev) => {
            // console.log(prev);
            // console.log(JSON.stringify(response.data));

            return {
                ...prev,
                accessToken: response?.data?.accessToken,
                refreshToken: response?.data?.refreshToken,
                foundUser: response?.data?.foundUser,
            }

        });

        // console.log(auth);
        return response?.data?.accessToken;
    }
    return refresh;
};

export default useRefreshToken;
